// return value from object by name or default
const _v = (obj, name, defaultValue) => {
  if (obj[name] === undefined) {
    if (defaultValue === undefined) {
      console.error(`No value passed for '${name}'`);
    } else {
      return defaultValue;
    }
  } else {
    return obj[name];
  }
};

class AuthSettings {
  constructor(opts) {
    this.accessExp = _v(opts, "accessExp", "29min");
    this.refreshExp = _v(opts, "refreshExp", "3d");
  }
}

class Settings {
  constructor(opts) {
    this.env = _v(opts, "env", false);
    this.debug = _v(opts, "debug");
    // api
    this.address = _v(opts  , "address");
    // site
    this.addres = _v(opts  , "addres");
    this.site = this.addres.substr(0,this.addres.length-1)
    this.auth = new AuthSettings(opts.auth)
    this.auth_url = _v(opts, "auth_url", "https://td.alliance.digital/#/login/?redirect=https://calc.alliance.digital/");
  }
  // replaces [host_name] with address of api
  formatWithHostName(str) {
    return str.replace("[host_name]", this.address);
  }

  // replaces [host_name] with address of site
  formatWithSiteAddress(str) {
    return str.replace("[host_name]", this.site);
  }
}

const MODE = process.env.VUE_APP_ENV || process.env.VUE_CLI_SERVICE_MODE || process.env.NODE_ENV;

function getSettings() {
  switch (MODE) {
    case  "production" : {
      return new Settings({
        env: process.env.NODE_ENV,
        debug: false,
        address: "https://calc.alliance.digital",
        addres: "https://calc.alliance.digital/",
        // auth_url: "https://demo.itd-team.ru/#/login/?redirect=https://calc.itd-team.ru/",
        auth_url: "https://td.alliance.digital/#/login/?redirect=https://calc.alliance.digital/",
        auth : {}
      });
    }
    case  "demo" : {
      return new Settings({
        env: process.env.NODE_ENV,
        debug: false,
        address: "https://calc-demo.alliance.digital",
        addres: "https://calc-demo.alliance.digital/",
        // auth_url: "https://demo.itd-team.ru/#/login/?redirect=https://calc.itd-team.ru/",
        auth_url: "https://td.alliance.digital/#/login/?redirect=https://calc-demo.alliance.digital/",
        auth : {}
      });
    }
    case "development" : {
      console.warn("DEVELOPMENT_LOCAL");
      return new Settings({
        env: process.env.NODE_ENV,
        debug: true,
        address: "http://localhost:8002",
        addres: "http://localhost:8002/",
        auth_url: "http://localhost:8000/#/login/?redirect=http://localhost:8080/",
        auth : {}
      });
    }
    default: {
      console.error("no env provided", process.env.NODE_ENV);
    }
  }
}

export default getSettings();